
import { useTranslation } from 'react-i18next';

//components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row, Col} from 'react-bootstrap';
import { DataTableCard } from './styled';

//utils

import { formatReal } from '../../../../../helpers';

export function StatementsTable(props: any) {
    const { t: translation } = useTranslation();
    const { nodes, treeFields, handleTableSort, sortField, sortOrder } = props;

    const month_names = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

    function dateTemplate(node: any) {
        let data = new Date(node.created_at)
        return (
            <h5 className="mt-2 mb-2">{data.getDate() + 1} {month_names[data.getMonth()]} {data.getFullYear()}</h5>
        );
    }

    function valueTemplate(node: any) {
        return (
            <Row>
                <Col className="text-end">
                    <div className="mb-2">{translation('manager.statements.balance')}</div>
                    <div>
                        {
                            node.status_transaction === 'Entrada' ? (
                                <>{translation('manager.statements.valueReceived')}</>
                            ) : (
                                <>{translation('manager.statements.valueWithdrawal')}</>
                            )
                        }
                    </div>
                </Col>
                <Col className="text-start">
                    <h5>&nbsp;&nbsp;&nbsp;{formatReal(node.balance.toFixed(2))}</h5>
                    <h5 className={node.status_transaction === 'Entrada' ? 'text-success' : 'text-danger'}>
                        {node.status_transaction === 'Entrada' ? '+' : '-'} {formatReal(node.value.toFixed(2))}
                    </h5>
                </Col>
            </Row>
        );
    }

    return (
        <div>
            <DataTableCard>
                <DataTable value={nodes} sortField={sortField} sortOrder={sortOrder} onSort={(e) => handleTableSort(e)} responsiveLayout="scroll">
                    {!!treeFields?.length && treeFields?.map((col: any) => {
                        if(col.dateTemplate) {
                            return <Column key={col.field} body={dateTemplate} field={col.field} header={col.header} style={ col.style } {...col} />;
                        } else if(col.valueTemplate) {
                            return <Column key={col.field} body={valueTemplate} field={col.field} header={col.header} style={ col.style } {...col} />;
                        } else {
                            return <Column key={col.field} field={col.field} header={col.header} style={ col.style } {...col} />;
                        }
                    })}
                    {props.children}                
                </DataTable>
            </DataTableCard>
        </div>
    );

}